export default __webpack_public_path__ + "static/media/SettingActive.5df41f4a.svg";